import { FETCH_PROFILE_SUCCESS, FETCH_PROFILE_REQUEST, FETCH_PROFILE_FAILURE, FETCH_PROFILE_RESET, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getProfilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROFILE_SUCCESS:
            console.log("Reducer Data: ", action.payload);
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_PROFILE_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_PROFILE_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_PROFILE_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getProfilesReducer;
